<template>
  <div>
    <label class="form-control-label">
      <h4>
        Campaign Info
        <span>(maximum 80 char, force new line with &lt;br /&gt;)</span>
      </h4>
    </label>
    <textarea
      rows="2"
      ref="info"
      type="text"
      v-model="info"
      maxlength="80"
      @change="update"
      :disabled="!canEdit"
      class="form-control"
    />
  </div>
</template>

<script>
import { wsgtdriveService } from "@/api/client";

export default {
  props: ["campaign"],

  data() {
    return {
      id: null,
      info: null,
    };
  },

  computed: {
    canEdit() {
      return ["draft", "ongoing"].includes(this.campaign.status);
    },
  },

  mounted() {
    this.id = this.campaign.id;
    this.info = this.campaign.info;
  },

  methods: {
    async update() {
      await wsgtdriveService.updateCampaignInfo(this.campaign.id, {
        info: this.info,
      });

      this.$notify(`Campaign info updated.`);
    },
  },
};
</script>

<style scope>
label h4 span {
  font-size: 14px;
  font-weight: 400;
}
</style>
